import React from 'react';
import AppCard from '../../../../../../appCard.js';
import { formatCurrency } from '../../../../../../../utils/formatCurrency.js';

/**
 * @typedef {object} SimulacaoResumoCardProps
 * @property {number|string|null} recebivelTipoValor
 * @property {boolean} descontoAtivado
 * @property {number|string|null} parcelaSimulado
 * @property {boolean} simulaParcelaValida
 * @property {number|string|null} simulaParcela
 * @property {number|string|null} valorParcela
 * @property {string} mostraDateSimulado
 */

/**
 * Card de resumo com o resultado da simulacao local.
 *
 * @param {SimulacaoResumoCardProps} props
 * @returns {JSX.Element}
 */
export default function SimulacaoResumoCard(props) {
    const {
        recebivelTipoValor,
        descontoAtivado,
        parcelaSimulado,
        simulaParcelaValida,
        simulaParcela,
        valorParcela,
        mostraDateSimulado,
    } = props;

    return (
        <AppCard className='p-10 mt-5 !shadow-none'>
            <p>Valor Total: R$: <b>{recebivelTipoValor}</b></p>
            {descontoAtivado &&
                <p>Valor Total com desconto:
                    <b>
                        {formatCurrency(parcelaSimulado)}
                    </b>
                </p>
            }
            {simulaParcelaValida &&
                <p>Valor de cada boleto: (<b>{simulaParcela}x</b>) <b>{formatCurrency(valorParcela)}</b><p className='text-sm'> + Taxas de serviço</p></p>
            }
            <p>Data do último vencimento: <b>{mostraDateSimulado}</b></p>
        </AppCard>
    );
}
